module.exports = __webpack_public_path__ + "static/media/icono_payaso.66750ea1.svg";